import { IEnvironmentInfo, IComponentInfo, IPackageInfo, IApplicationInfo, ComponentType } from './app-context.service';
import { LaborManagement_ModuleContextService } from './LaborManagement.context.service';

import { Injectable } from '@angular/core';
@Injectable({ providedIn: 'root' })
export class LaborManagement_operation_codes_dd_ComponentContextService {
  private readonly moduleContext: LaborManagement_ModuleContextService;

  constructor(moduleContext: LaborManagement_ModuleContextService) {
    this.moduleContext = moduleContext;
  }

  public get app(): IApplicationInfo {
    return this.moduleContext.app;
  }

  public get env(): IEnvironmentInfo {
    return this.moduleContext.env;
  }

  public get package(): IPackageInfo {
    return this.moduleContext.package;
  }

  public get component(): IComponentInfo {
    return {
      name: 'operation_codes_dd',
      type: ComponentType.selector
    }
  }
}